import { Component, h } from 'preact'
import Table from '../table/Table'
import UserCell from '../overview/cells/UserCell'
import axios from 'axios'
import AnalyticsDateFormatter from './AnalyticsDateFormatter'
import { Sort } from '../table/types'
import { Loader } from './Loader'

interface Props {
  startDate: Date,
  endDate: Date,
  selectedRoles: Array<string>,
  selectedRanks: Array<string>
}

interface SortingObject {
  [key: string]: any
}

interface UserRepresentation {
  userId: number,
  user: {
    id: number,
    username: string,
    avatar: string
  },
  posts: number,
  topics: number,
  replyCount: number,
  likesReceived: number,
  likesGiven: number,
  answersGiven: number
}

interface State {
  topUsers: Array<UserRepresentation>,
  sorting: Sort,
  isLoading: boolean
}

class TopUsersTable extends Component<Props, State> {
  constructor () {
    super()
    this.setState({
      topUsers: [],
      sorting: {
        order: 'posts',
        direction: 'desc'
      },
      isLoading: true
    })
  }

  async componentDidUpdate (prevProps: Props, prevState: State) {
    if (this.props.startDate !== prevProps.startDate || this.props.endDate !== prevProps.endDate || this.props.selectedRoles !== prevProps.selectedRoles || this.props.selectedRanks !== prevProps.selectedRanks) {
      await this.fetchTopUsers()
    }
  }

  async fetchTopUsers () {
    this.setState({ isLoading: true })
    try {
      const res = await this.fetchData('/analyticsV2/fetchTopUsers')
      this.setState({
        topUsers: res.data,
        isLoading: false
      })
    } catch {
      this.setState({ isLoading: false })
    }
  }

  async fetchData (url: string) {
    const { startDate, endDate, selectedRoles, selectedRanks } = this.props
    const filterOptions = {
      start: AnalyticsDateFormatter.formatDate(startDate),
      end: AnalyticsDateFormatter.formatDate(endDate, false),
      roles: selectedRoles,
      ranks: selectedRanks
    }
    return axios.post(url, {
      filters: filterOptions
    })
  }

  getModel () {
    return [
      { header: 'Username', accessor: 'user', cell: UserCell('user'), size: 'm' },
      { header: 'Posts', accessor: 'posts', size: 'xs-right', sorting: 'posts' },
      { header: 'Topics', accessor: 'topics', size: 'xs-right', sorting: 'topics' },
      { header: 'Replies', accessor: 'replyCount', size: 'xs-right', sorting: 'replyCount' },
      { header: 'Likes received', accessor: 'likesReceived', size: 'xs-right', sorting: 'likesReceived' },
      { header: 'Likes given', accessor: 'likesGiven', size: 'xs-right', sorting: 'likesGiven' },
      { header: 'Answers given', accessor: 'answersGiven', size: 'xs-right', sorting: 'answersGiven' }
    ]
  }

  render (_: Props, { topUsers, sorting, isLoading }: State) {
    return <div className='dashboard-table-wrapper'>
      {isLoading ? <Loader parentCustomClass='dashboard-table-loader' />
        : <Table model={this.getModel()}
          rows={topUsers}
          rowId={'userId'}
          classes={['top_users__table']}
          onSortChange={(attr) => {
            let newSorting: Sort
            if (sorting && sorting.order === attr) {
              newSorting = {
                order: attr,
                direction: sorting.direction === 'asc' ? 'desc' : 'asc'
              }
            } else {
              newSorting = {
                order: attr,
                direction: 'asc'
              }
            }
            topUsers.sort((a: SortingObject, b: SortingObject) => {
              if (a[attr] > b[attr]) return 1 * (newSorting.direction === 'asc' ? 1 : -1)
              if (a[attr] < b[attr]) return -1 * (newSorting.direction === 'asc' ? 1 : -1)
              return 0
            })
            this.setState({
              sorting: newSorting
            })
          }}
          sort={sorting}
          actionElements={<div className='title-top_users__table'> Top users</div>}
        />}
    </div>
  }
}

export default TopUsersTable
